exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ButtonRight-module__button___2CarP{background-color:#2daae1;color:#fff;padding:8px 16px 5px;border-radius:100px;width:fit-content;display:inline-block;font-size:12px;font-weight:400;border-width:0;transition:.1s;margin-top:30px;box-shadow:0 0 12px rgba(0,0,0,.1);margin-left:20px;float:right;cursor:pointer}.ButtonRight-module__button___2CarP:hover{transition:.1s;background-color:#1a9ac6}", ""]);

// exports
exports.locals = {
	"button": "ButtonRight-module__button___2CarP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/ButtonRight/ButtonRight.module.scss
// module id = 1PwF
// module chunks = 0